import { useState, useEffect } from "react";
import "../styles/globals.css";
import "../lib/polyfills"; // Import polyfills globally
import Shell from "../components/layout/shell";
import { useRouter } from "next/router";
import Head from "next/head";
import {ThemeProvider} from 'next-themes';

function MyApp({ Component, pageProps }) {
  const [isMounted, setIsMounted] = useState(false);

  const router = useRouter();

  useEffect(() => {
    if (router.isReady) {
      setIsMounted(true);
    }
  }, [router.isReady]);

  if (!isMounted) return null;

  const getLayout = Component.isUnprotected
    ? (page) => <ThemeProvider><div className="h-[100dvh] pb-[calc(100dvh-100vh)]">{page}</div></ThemeProvider>
    : (page) => <Shell>{page}</Shell>;

  return (
    <>
    <Head>
      <title>Workpeg</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover" />
    </Head>
      {getLayout(<Component {...pageProps} />)}
    </>
  );
}

export default MyApp;
